angular.module('UserBuildUpMain', [
  'angularSoundManager',
  'UserBuildUpControllers',
])

  .config(['$routeProvider', function($routeProvider) {
    $routeProvider

      .when('/buildup/on', {
        templateUrl: '/ng1/www/modules/user/practice/buildup/html/on.html',
        controller: 'BuildUpOnCtrl'
      })

  }
  ])
  /*
  .run(['nbModules', function(nbModules){
      nbModules.addModules(1);
  }])
  .run(['secondNavbar', function(secondNavbar){
      secondNavbar.addModules("Build Up", "/buildup", 2.5);
    }

  ])*/;
